<template>
  <create-dialog
    width="60%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div :class="`col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4`">
          <fg-input
            :label="`${$t('sowing.reason_rejection')}: *`"
            class="shadow-sm"
            ref="name"
            type="text"
            v-model="model.name"
            v-validate="modelValidations.name"
            name="sowing.nursery"
            :error="getError('sowing.nursery', true)"
            :placeholder="`${$t('common_words.name')}`"
          >
          </fg-input>
        </div>
        <div :class="`col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.type') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-type"
              size="large"
              v-model="model.type"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-if="rejectionType == 'Vivero'"
                class="select-primary"
                v-for="item in [
                  {
                    id: '1',
                    value: 'Vivero',
                    label: `${$t('sowing.nursery')}`,
                  },
                ]"
                :key="item.id + item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
              <el-option
                v-if="rejectionType == 'Poda'"
                class="select-primary"
                v-for="item in [
                  { id: '2', value: 'Poda', label: `${$t('sowing.prunning')}` },
                ]"
                :key="item.id + item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div :class="`col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.crops') }}: *</label>
            <br />
            <el-select
              @change="selectAllFromSelect('model.crops_id', crops)"
              collapse-tags
              clearable
              filterable
              multiple
              class="select-primary custom-width-select shadow-sm required-crops"
              size="large"
              v-model="model.crops_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in crops"
                class="select-primary selected-all"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div :class="`col-12`">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-reason-rejection',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
    rejectionType: {
      type: String,
      required: true,
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinLoading,
    MixinPermissions,
    MixinValidations,
  ],
  data() {
    return {
      businessesInitial: [],
      crops: [],
      disabledField: false,
      model: {
        name: null,
        type: null,
        businesses_id: [],
        businesses_names: [],
        crops_id: [],
      },
      modelValidations: {
        name: { required: true },
      },
    };
  },
  methods: {
    getSelectAll() {
      this.crops = this.concatAll(this.crops.splice(1));
    },
    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.type)) {
            return this.validationInputsRequired('type');
          } else if (!isset(this.model.crops_id)) {
            return this.validationInputsRequired('crops');
          } else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  mounted() {
    if (this.isCreate()) {
      Promise.all([Axios.getMasters('farms/crops')])
        .then(([responseCrops]) => {
          this.crops = this.concatAll(responseCrops.data.data);
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, name, type, crops } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = {
        ...this.model,
        id,
        name,
        type,
        crops_id: crops.map((crop) => crop.id),
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
